export default __webpack_public_path__ + "assets/images/65ac59d273ed41ec0de51a9886a2fbeb.webp";